// extracted by mini-css-extract-plugin
module.exports = {"InfoBar":"InfoBar_InfoBar__12Vwn","InfoRow":"InfoBar_InfoRow__3Qr37","Saving":"InfoBar_Saving__3WIMM"};